import { memo } from 'react'
import { Box, Button, Popover, Typography } from '@mui/material'
import Icon from '../icon'
import './index.scss'

export const FilterChip = memo(({ icon, label, value, isActive, onClick }) => {
  return (
    <Box className={`filter-chip`} onClick={onClick}>
      {icon && <Icon icon={icon} style={{ fontSize: '15px', flexShrink: 0 }} />}
      <Typography
        component="span"
        variant="inherit"
        className="filter-chip__label"
      >
        {label}
      </Typography>
      {value && (
        <>
          <Typography
            component="span"
            variant="inherit"
            className="filter-chip__separator"
          >
            :
          </Typography>
          <Typography
            component="span"
            variant="inherit"
            className="filter-chip__value"
          >
            {value}
          </Typography>
        </>
      )}
      <Icon
        icon="mdi:chevron-down"
        style={{
          fontSize: '16px',
          flexShrink: 0,
          transition: 'transform 0.2s ease',
          transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)'
        }}
      />
    </Box>
  )
})

export const FilterPopover = memo(
  ({ anchorEl, onClose, title, showClear, onClear, children }) => {
    return (
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ className: 'filter-popover-paper' }}
      >
        <Box className="filter-popover-header">
          <Typography className="filter-popover-title">{title}</Typography>
          {showClear && (
            <Button
              className="filter-clear-btn"
              onClick={() => {
                onClear()
                onClose()
              }}
            >
              Clear
            </Button>
          )}
        </Box>
        {children}
      </Popover>
    )
  }
)
